import {booleanAttribute, ChangeDetectionStrategy, Component, HostBinding, Input} from '@angular/core';
import {MyButtonComponent} from '../my-button/my-button.component';

@Component({
  selector: 'app-primary-button',
  templateUrl: './primary-button.component.html',
  styleUrls: ['./primary-button.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    MyButtonComponent,
  ]
})
export class PrimaryButtonComponent {
  @Input() label: string = '';
  @Input() icon?: string;
  @Input() color: string = 'primary';
  @Input({transform: booleanAttribute}) disabled: boolean = false;
  @Input({transform: booleanAttribute}) @HostBinding('class.w-full') fullWidth: boolean = true;
}
